import React from 'react';
import RatesAndTermsPage from '../components/RatesAndTermsPage';

const RatesAndTermsPageContainer = (props) => {
  return <RatesAndTermsPage {...props} />;
};

export default RatesAndTermsPageContainer;
